import type { ReactNode } from "react";

export const pageDescriptions: Record<string, ReactNode> = {
  // Dashboard
  "/dashboard":
    "Общая сводка по вашим объектам: количество объектов учёта и подключённых счётчиков.",

  // Assets
  "/assets/objects":
    "Список объектов учёта электроэнергии. Можно просматривать, фильтровать и редактировать адреса и договора.",
  "/assets/devices":
    "Реестр приборов учёта (счётчиков) и их каналов измерения. Фильтрация по объекту и заводскому номеру.",
  "/assets/connections":
    "Каналы связи и привязанные счётчики: порт, хост, интервал опроса, расписание.",

  // Monitoring
  "/monitoring/charts":
    "Графики телеметрии по выбранному объекту и периоду. В режиме «Группа» отображается суммарная телеметрия всех каналов группы.",
  "/monitoring/last-data":
    "Последние показания счётчиков: коммерческие и технические данные, параметры сети и значения на начало дня. Фильтр по номеру или серийному номеру счётчика.",
  "/monitoring/network":
    "Интервальные данные по сетевым параметрам. Выберите объект, счётчик и группу параметров для анализа.",
  "/monitoring/network-telemetry":
    "Временной ряд по мгновенной мощности (kW/kvar) и току (I). Значения показываются как исходные, так и с учётом коэффициента трансформации.",
  "/monitoring/vectors":
    "Векторная диаграмма: фазовые соотношения токов и напряжений. Выберите объект, счётчик и дату — измерения загрузятся за сутки.",
  "/monitoring/events":
    "Журнал событий на счётчиках: аварии, предупреждения и диагностические сообщения. Фильтрация по объекту, номеру счётчика и типу события.",

  // Analytics
  "/analytics/readings":
    "Показания приборов учёта за выбранный период. Можно считать энергию по профилю (сумма интервалов) или по регистрам (разность показаний).",
  "/analytics/tou":
    "Тарифные данные по зонам суток: регистры T1–T4 и суммарное значение T0 для каждого счётчика объекта.",
  "/analytics/autoread":
    "Суточные показания приборов учёта: значения регистров на 00:00, фиксируемые из памяти счётчика раз в сутки. Можно переключить отображение тарифов.",
  "/analytics/profile":
    "Профильные (получасовые) данные электропотребления. Можно переключать режим «Энергия/Мощность» и интервал агрегации.",
  "/analytics/power-quality":
    "Качество электроэнергии: мощность по интервалам, приём и отдача, шаг усреднения и единицы измерения (кВт·ч или МВт·ч).",
  "/analytics/matrix":
    "Матричная таблица показаний по интервалам для одного счётчика. Выбор месяца, режима (энергия/мощность) и шага интервала.",

  // Communications
  "/comms/state":
    "Текущий статус связи со счётчиками: онлайн, в опросе, оффлайн, с ошибками. Расхождение времени и дата последнего опроса.",
  "/comms/errors":
    "Счётчики с ошибками связи или протокола. Автоматически фильтруются только устройства с проблемами.",
  "/comms/outages":
    "Счётчики, с которыми потеряна связь: время отключения, последний ответ, детали ошибок.",
  "/comms/drift":
    "Расхождение часов счётчиков относительно сервера. Порог фильтрации настраивается (по умолчанию 5 сек).",
  "/comms/events":
    "История событий по УСПД (коллекторам): перезагрузки, сбои, обновления. Фильтрация по ID устройства и дате.",
  "/comms/polling-log":
    "Журнал опроса: детальный протокол взаимодействия с приборами учёта. Фильтр по объекту, счётчику, коду события и дате.",

  // Support & Settings
  "/support/tickets":
    "Ваши обращения в поддержку. Можно создать новый чат и отслеживать статус (новый, в работе, закрыт).",
  "/settings/profile": "Ваш профиль: личные данные, контакты и настройки уведомлений.",

  // Admin
  "/admin/users":
    "Справочник пользователей системы: роли, контакты, статусы. Создание новых пользователей и импорт из внешних источников.",
  "/admin/groups":
    "Группы счётчиков для агрегации данных. Создание групп, назначение счётчиков и импорт из внешних источников.",
  "/admin/contracts":
    "Справочник договоров с привязкой счётчиков: номер, контрагент, сроки действия, тип учёта.",
  "/admin/integrations":
    "Настройка внешних интеграций: почта (Resend/SMTP), объектное хранилище (S3), Telegram-уведомления.",
  "/admin/mail":
    "Журнал отправленных email-сообщений: получатель, тема, статус доставки, вложения.",
  "/admin/templates":
    "Шаблоны автоматических email-сообщений: OTP, уведомления, отчёты. Редактор с подстановкой переменных.",
};
